import { SITE_YANDEX_METRIKA, SITE_YANDEX_METRIKA_COUNTER } from '@/config/site'
import { getHelp } from '@/services/Api/actions/help/actions'
import { HelpTypeSite } from '@/services/Api/generated'
import { Validator } from '@/services/Validator'
import {
  acceptTermsValidator,
  phoneWithFormatValidator,
} from '@/services/Validator/utils/rules'
import {
  maxPopupStore,
  maxRequestFormTexts,
} from '@/domains/Site/store/MaxPopup.store'
import { Loader } from '@/helpers/Loader'
import { marketingStorage } from '@/store/MarketingStorage'
import { makeAutoObservable } from 'mobx'
import { toast } from 'react-toastify'
import { object } from 'yup'

const schema = object().shape({
  phone: phoneWithFormatValidator,
  accept: acceptTermsValidator,
})

export class HelpExpertFormStore {
  data: {
    phone: string
    accept: boolean
  } = {
    phone: '',
    accept: false,
  }

  validator = new Validator(schema)

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  loaderSend = new Loader(async (captchaToken: string) => {
    if (this.validator.validateAll(this.data) === false) {
      return
    }

    const response = await getHelp(
      {
        type: HelpTypeSite.HelpLawyer,
        data: {
          sourceUrl: window.location.href.split('?')[0],
          phone: this.data.phone,
          utmClientId: marketingStorage.getClientId() ?? undefined,
        },
      },
      captchaToken
    )

    if (response.status) {
      marketingStorage.clearClientId()
      if (SITE_YANDEX_METRIKA) {
        ym(SITE_YANDEX_METRIKA_COUNTER, 'reachGoal', 'FORM_HELP_EXPERT_SUBMIT')
      }

      this.setPhone('')
      this.setAccept(false)

      maxPopupStore.show({
        sourceSite: response.data.params,
        ...maxRequestFormTexts,
      })
    } else {
      toast.error('Что то пошло не так! Попробуйте позже')
    }
  })

  setPhone(phone: string) {
    this.data.phone = phone
    if (this.validator.errors.phone != null) {
      this.validator.validateAt('phone', phone)
    }
  }

  setAccept(value: boolean) {
    this.data.accept = value
    if (this.validator.errors.accept != null) {
      this.validator.validateAt('accept', value)
    }
  }
}
